import type { FieldChange } from "@/application/merchants/business_info_edit";

interface Props {
  changes: FieldChange<string>[];
  /** The "This will also" lines. */
  effects: string[];
}

/** The old → new list and the follow-on effects shown before a save. */
export function ReviewChanges({ changes, effects }: Props) {
  return (
    <>
      <ul className="space-y-2">
        {changes.map((c) => (
          <li key={c.field} className="border-border rounded-md border p-3">
            <p className="text-muted-foreground text-xs">{c.label}</p>
            <p className="text-sm">
              <span className="text-muted-foreground line-through">
                {c.before || "(empty)"}
              </span>{" "}
              → <span className="font-medium">{c.after}</span>
            </p>
          </li>
        ))}
      </ul>

      <div className="text-xs">
        <p className="text-foreground font-medium">This will also:</p>
        <ul className="text-muted-foreground list-disc pl-5">
          {effects.map((line) => (
            <li key={line}>{line}</li>
          ))}
        </ul>
      </div>
    </>
  );
}
